import { render, staticRenderFns } from "./managerProp.vue?vue&type=template&id=8a40cd0a&scoped=true&"
import script from "./managerProp.vue?vue&type=script&lang=js&"
export * from "./managerProp.vue?vue&type=script&lang=js&"
import style0 from "./managerProp.vue?vue&type=style&index=0&id=8a40cd0a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a40cd0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a40cd0a')) {
      api.createRecord('8a40cd0a', component.options)
    } else {
      api.reload('8a40cd0a', component.options)
    }
    module.hot.accept("./managerProp.vue?vue&type=template&id=8a40cd0a&scoped=true&", function () {
      api.rerender('8a40cd0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/activity/leadPlan/detail/managerProp.vue"
export default component.exports